module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>edit_view_advanced sort_o2</title><polygon points=\"803.29 803.74 803.29 2 657.7 2 657.7 803.97 512 804.21 730.49 1022 948.98 803.51 803.29 803.74\"/><polygon points=\"220.71 220.26 220.71 1022 366.31 1022 366.31 220.03 512 219.79 293.51 2 75.02 220.49 220.71 220.26\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/grid-sort.svg
// module id = 162
// module chunks = 0